
import Icon from '@material-ui/icons/PlaylistAddCheck';
import List from './CheckList'
import Create from './CheckListCreate'
import Edit from './CheckListEdit'

export default {
    list: List,
    icon: Icon,
    create:  Create,
    edit: Edit,
};

